import noVotesColorEmoticon from '../assets/icons/color-emoticons/none.svg';
import noVotesFaceEmoticon from '../assets/icons/face-emoticons/face-none.svg';
import noVotesCityLogo from '../assets/logos/hwa-nyc-none.svg';

// Paleta de colores exacta que coincide con los emoticonos
export const COLOR_PALETTE = [
    { range: [0, 5], color: '#E61413' },     // [0, 5]
    { range: [5, 10], color: '#E82711' },    // [5, 10]
    { range: [10, 15], color: '#EB3710' },   // [10, 15]
    { range: [15, 20], color: '#ED4C0D' },   // [15, 20]
    { range: [20, 25], color: '#F0620C' },   // [20, 25]
    { range: [25, 30], color: '#F37509' },   // [25, 30]
    { range: [30, 35], color: '#F58607' },   // [30, 35]
    { range: [35, 40], color: '#F89B06' },   // [35, 40]
    { range: [40, 45], color: '#FBB203' },   // [40, 45]
    { range: [45, 50], color: '#FDC602' },   // [45, 50]
    { range: [50, 55], color: '#F4CF03' },   // [50, 55]
    { range: [55, 60], color: '#E2CB08' },   // [55, 60]
    { range: [60, 65], color: '#C9C60E' },   // [60, 65]
    { range: [65, 70], color: '#B4C213' },   // [65, 70]
    { range: [70, 75], color: '#9FBE18' },   // [70, 75]
    { range: [75, 80], color: '#88B91E' },   // [75, 80]
    { range: [80, 85], color: '#71B525' },   // [80, 85]
    { range: [85, 90], color: '#5FB22A' },   // [85, 90]
    { range: [90, 95], color: '#49AD30' },   // [90, 95]
    { range: [95, 100.1], color: '#32A936' } // [95, 100.1]
];

export const NO_VOTES_COLOR = '#9AA7A9';

// Función para obtener el color basado en el porcentaje
export const getColorForPercentage = (percentage: number) => {
  const found = COLOR_PALETTE.find(item => percentage >= item.range[0] && percentage < item.range[1]);
  return found ? found.color : '#E1D4C3'; // Color por defecto
};

// Función para obtener el emoticón correspondiente al porcentaje de votos positivos
export const getEmotionIconByPercentage = (positivePercentage: number): string | null => {
    const found = COLOR_PALETTE.find(item => positivePercentage >= item.range[0] && positivePercentage < item.range[1]);
    if (found) {
        const [start, end] = found.range;
        const endRange = end === 100.1 ? 100 : end;
        const iconName = `${start}-${endRange}.svg`;
        try {
            // Usamos require para importar dinámicamente los iconos.
            // Webpack se encargará de empaquetar todos los svgs del directorio.
            return require(`../assets/icons/color-emoticons/${iconName}`);
        } catch (err) {
            console.error(`Icono no encontrado: ${iconName}`, err);
            return null;
        }
    }
    return null;
};

// Función para obtener el icono de cara correspondiente al porcentaje de votos positivos
export const getFaceIconByPercentage = (positivePercentage: number): string | null => {
    const found = COLOR_PALETTE.find(item => positivePercentage >= item.range[0] && positivePercentage < item.range[1]);
    if (found) {
        const [start, end] = found.range;
        const endRange = end === 100.1 ? 100 : end;
        const iconName = `${start}-${endRange}.svg`;
        try {
            return require(`../assets/icons/color-emoticons/${iconName}`);
        } catch (err) {
            console.error(`Icono de cara no encontrado: ${iconName}`, err);
            return null;
        }
    }
    return null;
};

// Función para obtener el logo de la ciudad según el porcentaje de votos positivos
export const getCityLogoByPercentage = (positivePercentage: number): string | null => {
    const found = COLOR_PALETTE.find(item => positivePercentage >= item.range[0] && positivePercentage < item.range[1]);
    if (found) {
        const [start, end] = found.range;
        const endRange = end === 100.1 ? 100 : end;
        const logoName = `hwa-nyc-${start}-${endRange}.svg`;
        try {
            return require(`../assets/logos/${logoName}`);
        } catch (err) {
            console.error(`Logo no encontrado: ${logoName}`, err);
            return null;
        }
    }
    return null;
};

export const getNoVotesEmotionIcon = (): string | null => {
    return noVotesColorEmoticon;
};

export const getNoVotesFaceIcon = (): string | null => {
    return noVotesFaceEmoticon;
};

export const getNoVotesCityLogo = (): string | null => {
    return noVotesCityLogo;
};